import { Spinner } from "react-bootstrap";

export default function ContentLoader({ size = 'lg', color = "white" }) {
    return (
        <div className="w-100 my-4 d-flex justify-content-center align-items-center">
            <Spinner size={size} className={`text-${color}`} />
        </div>
    )
}